export const apiUrl = process.env.REACT_APP_API_URL;
console.log("🚀 ~ process.env.REACT_PUBLIC_API_URL:", process.env.REACT_APP_API_URL)

